import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const TrashBinIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M9.61161 2.41875L8.76339 3.75H15.2366L14.3884 2.41875C14.3214 2.31562 14.2098 2.25 14.0893 2.25H9.90625C9.78571 2.25 9.67411 2.31094 9.60714 2.41875H9.61161ZM16.1741 1.17188L17.8125 3.75H18.4286H20.5714H20.9286C21.5223 3.75 22 4.25156 22 4.875C22 5.49844 21.5223 6 20.9286 6H20.5714V20.25C20.5714 22.3219 18.9732 24 17 24H7C5.02679 24 3.42857 22.3219 3.42857 20.25V6H3.07143C2.47768 6 2 5.49844 2 4.875C2 4.25156 2.47768 3.75 3.07143 3.75H3.42857H5.57143H6.1875L7.82589 1.16719C8.29018 0.440625 9.07143 0 9.90625 0H14.0893C14.9241 0 15.7054 0.440625 16.1696 1.16719L16.1741 1.17188ZM5.57143 6V20.25C5.57143 21.0797 6.20982 21.75 7 21.75H17C17.7902 21.75 18.4286 21.0797 18.4286 20.25V6H5.57143ZM9.14286 9V18.75C9.14286 19.1625 8.82143 19.5 8.42857 19.5C8.03571 19.5 7.71429 19.1625 7.71429 18.75V9C7.71429 8.5875 8.03571 8.25 8.42857 8.25C8.82143 8.25 9.14286 8.5875 9.14286 9ZM12.7143 9V18.75C12.7143 19.1625 12.3929 19.5 12 19.5C11.6071 19.5 11.2857 19.1625 11.2857 18.75V9C11.2857 8.5875 11.6071 8.25 12 8.25C12.3929 8.25 12.7143 8.5875 12.7143 9ZM16.2857 9V18.75C16.2857 19.1625 15.9643 19.5 15.5714 19.5C15.1786 19.5 14.8571 19.1625 14.8571 18.75V9C14.8571 8.5875 15.1786 8.25 15.5714 8.25C15.9643 8.25 16.2857 8.5875 16.2857 9Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default TrashBinIcon
